module.exports = __webpack_public_path__ + "static/media/practice-menu.892af09f.svg";